export default "__VITE_ASSET__B0U05O5Z__"